import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { RounderContainer } from '@r1-frontend/ui-react/experimental/containers';

export const Carousel = styled(NukaCarousel)`
    padding-bottom: 0;
    
    .slider-frame {
        border-radius: 32px;

        @media (max-width: ${wideBreakpoints.mobile}) {
            border-radius: 24px;
        }
    }

    ${RounderContainer} {
        border-radius: 0;
    }

    .slider-control-bottomcenter {
        bottom: 24px !important;
    
        @media (max-width: ${wideBreakpoints.laptop}) {
            bottom: 16px !important;
        }
    
        @media (max-width: ${wideBreakpoints.tablet}) {
            bottom: 8px !important;
        }
    }
`;
